import {
	ICommunicationReducer,
	ICustomizationTemplate,
	IEmailTemplateResponse,
	ITemplate,
} from '@/utils/types/organization-communication.interface';
import {PayloadAction} from '@reduxjs/toolkit';

export const pendingOperation = (state: ICommunicationReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: ICommunicationReducer) => {
	state.isLoading = false;
	state.communicationTemplate = null;
};

export const getEmailTemplateOperation = (
	state: ICommunicationReducer,
	{payload}: PayloadAction<ICustomizationTemplate>
) => {
	state.isLoading = false;
	state.communicationTemplate = payload;
};

export const getAllEmailTemplatesOperation = (state: ICommunicationReducer, {payload}: PayloadAction<ITemplate[]>) => {
	state.isLoading = false;
	state.templates = payload;
};
export const getOneEmailTemplateByTypeOperation = (
	state: ICommunicationReducer,
	{payload}: PayloadAction<IEmailTemplateResponse>
) => {
	state.isLoading = false;
	state.templates = state.templates.map((template) => {
		return template.templateId === payload.id ? {...template, ...payload} : template;
	});
};

export const updateOneEmailTemplateByTypeOperation = (
	state: ICommunicationReducer,
	{payload}: PayloadAction<IEmailTemplateResponse>
) => {
	state.isLoading = false;
	state.templates = state.templates.map((template) => {
		return template.templateId === payload.id ? {...template, ...payload} : template;
	});
};
